<!-- Start Footer Area -->
<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <div class="logo">
                        <a href="#"><img src="assets/image/logo-2.png" alt="image"></a>
                        <!-- <h3>SOLARCITI</h3> -->
                        <p>
                            <strong>SolarCiti</strong> delivers smart, reliable solar solutions that help homes and
                            businesses save energy, reduce costs, and build a sustainable future.
                        </p>
                    </div>

                    <ul class="social">
                        <li><a href="#" target="_blank"><i class="flaticon-facebook-letter-logo"></i></a></li>
                        <li><a href="#" target="_blank"><i class="flaticon-twitter-black-shape"></i></a></li>
                        <li><a href="#" target="_blank"><i class="flaticon-instagram-logo"></i></a></li>
                        <li><a href="#" target="_blank"><i class="flaticon-youtube"></i></a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Quick Links</h3>

                    <ul class="quick-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/about">About Us</a></li>
                        <li><a routerLink="/contact">Contact</a></li>
                        <li><a routerLink="blog">Blog</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Services</h3>

                    <ul class="footer-services-list">
                        <li><a routerLink="on-grid">On-Grid Solar System</a></li>
                        <li><a routerLink="off-grid">Off-Grid Solar System</a></li>
                        <li><a routerLink="hybrid">Hybrid Solar System</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Contact Us</h3>

                    <ul class="footer-contact-list">
                        <li><span>Address:</span> 143, Balaji Tower MG Road Rajwada, Indore, Madhya Pradesh</li>
                        <li><span>Email: </span> <a href="mailto:sales@solarciti.in"> sales@solarciti.in</a></li>
                        <li><span>Phone: </span> <a href="tel:9575502277"> +91 95755 02277</a></li>

                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="copyright-area">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <p>&copy; Copyright 2026 <a href="#">SolarCiti</a>. All Rights Reserved.</p>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <ul>
                        <li><a routerLink="privacy-policy">Privacy Policy</a></li>
                        <li><a routerLink="terms-conditions">Terms & Conditions</a></li>
                    </ul>
                </div>
                <div class="col-lg-5 col-md-6 col-sm-6" style="text-align: right;">
                    <p>Designed & Maintained by <a target="_blank" href="https://www.amstechinc.com" rel="nofollow">
                            Amstech Incorporation Private Limited</a>
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="circle-map"><img src="assets/img/circle-map.png" alt="image"></div>
    <!-- <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div> -->
</footer>
<!-- End Footer Area -->
<div class="go-top"><i class="fas fa-arrow-up"></i><i class="fas fa-arrow-up"></i></div>